import { ControlBoot } from '../../../shared/ui/LoadingState.jsx';
import { DoroPartyWordmark } from '../../../shared/ui/DoroPartyWordmark.jsx';
import { SiteFooter } from '../../../shared/ui/SiteFooter.jsx';
import { SupabaseStatus } from '../../../shared/ui/SupabaseStatus.jsx';
import { PersonalCodeAuthContent } from '../shared/PersonalCodeAuthContent.jsx';
import { BroadcastEntryButton } from '../../broadcast/shared/BroadcastEntryButton.jsx';

export function DesktopAuthScreen() {
  return (
    <div className="desktop-auth-shell">
      <section className="desktop-auth-brand-panel">
        <p className="section-eyebrow">NIKKE UNION RAID PLATFORM</p>
        <h1><DoroPartyWordmark showKorean /></h1>
        <p>DC 갤로그 작성자 또는 아카라이브 상태 메시지로 본인을 인증하고 BlablaLink에서 실제 게임 계정과 유니온을 연결합니다.</p>
        <div className="desktop-auth-status-row"><SupabaseStatus /></div>
      </section>
      <section className="desktop-auth-card" aria-label="DoroParty 개인 코드 인증">
        <PersonalCodeAuthContent />
        <div className="broadcast-auth-entry">
          <div className="broadcast-auth-divider"><span>또는</span></div>
          <BroadcastEntryButton />
        </div>
      </section>
      <SiteFooter compact />
    </div>
  );
}

export function DesktopAuthLoading() {
  return <ControlBoot stage="session" />;
}
